/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNetworkBox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M17.47 12.152a1.001 1.001 0 0 1 1.06 0l4 2.5a1 1 0 0 1 .47.848v4a1 1 0 0 1-.47.847l-4 2.5a1.001 1.001 0 0 1-1.06 0l-4-2.5A1 1 0 0 1 13 19.5v-4a1 1 0 0 1 .47-.848zM15 18.945l2 1.25v-1.642l-2-1.25zm4-.392v1.642l2-1.25v-1.642zM15.886 15.5 18 16.82l2.113-1.32L18 14.178z" />
        <path d="M10.895 3.916a3.789 3.789 0 1 1 5.852 4.673l.702 2.093-1.897.636-.604-1.8a3.78 3.78 0 0 1-1.987-.12l-4.405 6.35c.354.372.622.809.798 1.278l1.309-.468.674 1.884-1.81.646a3.788 3.788 0 1 1-2.687-4.375l4.462-6.435a3.79 3.79 0 0 1-.407-4.362zM6.704 16.81a1.79 1.79 0 1 0-1.79 3.1 1.79 1.79 0 0 0 1.79-3.1zM15.07 4.26a1.789 1.789 0 1 0-1.788 3.1 1.789 1.789 0 0 0 1.788-3.1z" />
      </g>
    </g>
  </Icon>
);
export { SvgNetworkBox as NetworkBox };
